/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconPlayerKing: {
  name: 'player_king';
  data: string;
} = {
  name: 'player_king',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="m306.291 57.442-18.653 50.13-25.065-46.633-9.327 47.799-35.557-44.884 5.247 64.595c22.031 22.031 144.357 22.354 166.712 0l4.664-64.595-35.557 44.884-9.327-47.799-25.065 46.05-18.07-49.547h-.002zM308.253 169.236c-52.487 0-95.085 54.446-95.085 121.534 0 35.693 12.506 67.621 31.694 89.862-101.708 23.173-108.351 104.486-108.351 223.181h344.956c0-118.254 1.447-204.059-107.615-225.391 17.994-22.117 29.482-53.249 29.482-87.652 0-67.087-42.597-121.534-95.085-121.534h.004z"/></svg>`,
};
